const vanityUrls = {
    "/driveelectric" : "/driveelectric?utm_source=mail&utm_medium=mail&utm_campaign=Res Onsert"
}

export { vanityUrls }